import { useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Typography from 'components/global/Typography';
import VideoPreview from 'components/global/VideoPreview';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import * as S from './ModuleDetail.styled';

const ModuleGuide = () => {
	const { selectedModule } = useSelector((state) => state.otoPackageList);
	const { t } = useTranslation();
	const [activeGuide, setActiveGuide] = useState(null);

	const isMobile = useMediaQuery(Breakpoints.mobile);
	const guides = useMemo(() => {
		const guides = [];
		for (let stepNumber = 1; stepNumber < 20; stepNumber += 1) {
			const titleKey = `${selectedModule?.slug}.guide${stepNumber}`;
			const descriptionKey = `${selectedModule?.slug}.guide${stepNumber}.description`;
			const imageKey = `${selectedModule?.slug}.guide${stepNumber}.image`;
			if (t(titleKey) !== titleKey && t(descriptionKey) !== descriptionKey) {
				guides.push({
					title: titleKey,
					description: descriptionKey,
					image: t(imageKey)
				});
			} else {
				break;
			}
		}
		setActiveGuide(guides[0]);
		return guides;
	}, [selectedModule]);

	if (guides.length === 0) {
		return null;
	}

	return (
		<S.Guide>
			<Typography variant="h2" fontWeight="800" noWrap align="center">
				<Trans i18nKey={`${selectedModule?.slug}.guide.title`} />
			</Typography>
			<S.GuideList>
				<S.GuideContent>
					{guides?.map((item) => (
						<S.GuideItem key={item.title}>
							<S.GuideButton
								onClick={() => setActiveGuide(item)}
								isActive={activeGuide?.title === item.title}>
								<S.GuideText>
									<Typography
										variant="p1"
										fontWeight={activeGuide?.title === item.title ? '700' : '500'}>
										{item.title}
									</Typography>
									{activeGuide?.title === item.title && (
										<Typography
											variant="p2"
											color="var(--content-2)"
											noWrap
											className="description">
											<Trans i18nKey={item.description} />
										</Typography>
									)}
								</S.GuideText>
							</S.GuideButton>
							{activeGuide?.title === item.title && isMobile && <VideoPreview videoLink={item.image} />}
						</S.GuideItem>
					))}
				</S.GuideContent>
				{!isMobile && <VideoPreview videoLink={activeGuide?.image} />}
			</S.GuideList>
		</S.Guide>
	);
};

export default ModuleGuide;
